//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import editableDiv from './editable-div.vue';
import SquareButton from './square-button.vue';
import {fromMatchingDb} from '../utils.js';
import {Item, generateId} from '../item.js';
import {defaultListID} from '../reactive-cache.js'
import {
  reorderTasks,
  multiRelationAppend,
} from '../ordered-relation.js';
import {
  parseMarkdown,
  formatTaskName,
  parseDuration,
} from '../format-task-name.js';
import {addOrganizerLinkToDescription} from '../gcalendar-utils'

let componentInstanceID = 0;

export default {
  props: ['parent'],
  data() {
    return {
      itemName: '',
      itemType: 'task',
      focused: false,
      showInput: false,
      menuOpen: false,
      detailsFocus: false,
      isMobile: (('ontouchstart' in window) ||
                 (window.navigator.msMaxTouchPoints > 0)),
      // Md-select complains when used with full objects.
      targetDBname: this.parent.couch.name,
      targetListName: defaultListID(this.parent.couch)
    };
  },
  components: {
    editableDiv,
    SquareButton,
  },
  computed: {
    iconName() {
      switch (this.itemType) {
        case 'note': return 'notes';
        case 'task': return 'check_box';
        case 'goal': return 'flag';
      }
    },
    placeholderText() {
      switch (this.itemType) {
        case 'note': return this.$gettext('Add a note...');
        case 'task': return this.$gettext('Add a task...');
        case 'goal': return this.$gettext('Add a goal...');
      }
    },
    possibleLists() {
      return fromMatchingDb(
        this.$root.allSubtaskOfLists,
        this.$sessionState.dbs[this.targetDBname],
      )
    },
    enableOwnerPicker() {
      return this.$root.hasSharing
          && !this.parent._id
          && this.parent.relation !== 'subtaskOf'
    },
    enableListPicker() {
      return this.$settings?.multilist !== false
          && this.$root.allSubtaskOfLists.length > 1
          && this.possibleLists.length > 1
          && this.parent.relation !== 'subtaskOf'
    },
    noBacklogByDefault() {
      return this.$settings && this.$settings.backlogByDefault !== true;
    },
  },
  methods: {
    createItem() {
      if (!this.itemName) {
        return false;
      }
      if (this.parent.type === "event") {
        addOrganizerLinkToDescription(this.parent)
      }

      const doc = {
        _id: generateId("task"),
        name: this.itemName.trim(),
        type: this.itemType,
      };
      const html = parseMarkdown(doc.name);
      if (html) {
        doc.html = html;
      }
      const formattedNameTokens = formatTaskName(doc.name);
      if (formattedNameTokens) {
        doc.formattedNameTokens = formattedNameTokens;
      }
      const duration = parseDuration(doc.name)
      if (duration) {
        doc.dur = duration;
      }
      const db = this.$sessionState.dbs[this.targetDBname]
      const item = new Item(doc, this.$reactiveCache, db)
      const options = {
        db,
        reactiveCache: this.$reactiveCache,
        task: item,
      };

      if (!this.parent._id && !this.parent.key) {
        console.error("Invalid parent:", this.parent)
        return false;
      }

      let simpleInsert = false;

      // adding a subtask (in task view or to a task column in board)
      if (this.parent._id || this.parent.class === "task") {
        options.relation = 'subtaskOf'
        options.newPPtr = {
          // ugh fallback for task view
          parentClass: this.parent.class || this.parent?._id?.split(":")[0] || "task",
          // TODO: unify.
          parentKey: this.parent._id || this.parent.key,
        }
        simpleInsert = true;
      } else if (this.parent.relation === "subtaskOf" && this.noBacklogByDefault) {
        // adding a "top-level" task in a section
        options.relation = this.parent.relation
        options.newPPtr = {
          parentClass: this.parent.class || this.parent?._id?.split(":")[0] || "list",
          // TODO: unify.
          parentKey: this.parent._id || this.parent.key,
        }
        simpleInsert = true;
      }

      if (simpleInsert) {
        reorderTasks(options).catch((error) => {
          // TODO: Show the error in UI, handle it sensibly.
          console.error("Cannot sort item into place:", error);
          return false;
        });
        return true;
      }

      // need to set multiple parents
      if (this.parent.relation === 'subtaskOf') {
        options.subtaskOf = {
          parentClass: this.parent.class,
          parentKey: this.parent.key,
        }
        options.relation = 'plannedFor'
        options.newPPtr = {
          parentClass: "list",
          parentKey: "backlog",
        }
      } else {
        options.subtaskOf = {
          parentClass: "list",
          parentKey: this.targetListName,
        }
        options.relation = this.parent.relation
        options.newPPtr = {
          parentClass: this.parent.class,
          parentKey: this.parent.key,
        }
      }
      multiRelationAppend(options).catch((error) => {
        // TODO: Show the error in UI, handle it sensibly.
        console.error("Cannot sort item into place:", error);
        return false;
      });
      return true;
    },
    // This is attached to mousedown rather than click because when something
    // triggers hiding mobile keyboard, it messes with click events.
    createAndClear() {
      if (this.createItem()) {
        this.itemName = '';
      }
    },
    createIfMobileEnter(event) {
      // on desktop textInput is triggered on every key (with data containig 1 char),
      // on mobile it's triggered on enter with whole input inside data.
      if (event.type === "textInput"
          && event.data.length > 1
          && event.data.slice(-1) === "\n") {
        event.preventDefault();
        this.createAndClear()
      }
    },
    createUnlessWithShift(event) {
      if (event.shiftKey) {
        // Keep default behavior of adding a newline.
        return;
      }
      event.preventDefault();
      this.createAndClear()
    },
    openInput(type) {
      this.itemType = type
      this.showInput = true
      this.$nextTick(() => {
        this.focusOnInput();
      });
    },
    setItemType(type) {
      this.itemType = type
      this.focusOnInput();
    },
    focusOnInput() {
      this.$refs.NameInput.focus();
    },
    onFocus(focusOn) {
      this.focused = true;
      this.$taskCardsController.focusOnNewTaskCard = true;
      if (this.isMobile) {
        this.scrollIntoView();
        // Showing the keyboard may take some time, and it may obscure
        // the card. Scrolling into view before that doesn't work if there
        // is not enough page in the bottom.
        window.addEventListener('resize', this.scrollIntoView);
      }
    },
    onBlur() {
      this.focused = false;
      setTimeout(() => {  // Wait in case it's setItemType or changing owner.
        if (!this.menuOpen && !this.detailsFocus && this.itemName === '') {
          this.showInput = false;
        }
      }, 150);
      this.$taskCardsController.focusOnNewTaskCard = false;
      if (this.isMobile) {
        window.removeEventListener('resize', this.scrollIntoView);
      }
    },
    scrollIntoView() {
      this.$el.scrollIntoView({behavior: 'smooth', block: 'center'});
    },
  },
  beforeCreate() {
    this.componentInstanceID = componentInstanceID.toString();
    componentInstanceID += 1;
  },
  beforeDestroy() {
    if (this.focused) {
      this.$taskCardsController.focusOnNewTaskCard = false;
    }
  },
  watch: {
    targetDBname() {
      this.targetListName = defaultListID(this.$sessionState.dbs[this.targetDBname])
    }
  }
};
